<template>
  <div>
    <div class="pageloader is-active has-text-centered">
      <span class="title" v-html="$t('loading.licence')"></span>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    // on récupère un éventuel initSearch depuis l'URL et on le stocke dans le store state si il existe
    var initSearch = this.readinitSearchUrlHashParams();
    if (initSearch) {
      this.$store.dispatch("setInitSearch", { initSearch: initSearch });
    } else {
      this.$store.dispatch("setInitSearch", { initSearch: "" });
    }

    // on récupère un éventuel token depuis l'URL et on le stocke dans le store state si il existe
    var tokenURL = this.readUrlHashParams();
    if (tokenURL) {
      this.$store.dispatch("setTokenURL", { tokenURL: tokenURL });
    }
    // On teste si le token  est vide dans le store (vide = pas de token en URL ou pas de token en mémoire localstorage) - on  vire le gars vers APPYPACK
    if (!this.$store.getters.userToken) {
      window.location = process.env.URL_SSO_FRONT;
    } else {
      // on fait une demande de récupération de user/me avec ce token de connexion 'mis à jour ou en mémoire'
      this.$store.dispatch("requireAuth");
    }
  },
  methods: {
    // change lang
    choosenLanguageFunction(value) {
      this.$i18n.locale = value;
      this.$store.dispatch("changeLangue", value);
    },
    readUrlHashParams() {
      var urlString = window.location.href;
      var url = new URL(urlString);
      var token = url.searchParams.get("t");
      var idEntreprise = url.searchParams.get("e");
      var idPlateforme = url.searchParams.get("p");
      var langColidee = url.searchParams.get("l");
      if (idEntreprise && idPlateforme) {
        this.$store.dispatch("setIframeColidee", true);
        this.choosenLanguageFunction(langColidee);
      } else {
        this.$store.dispatch("setIframeColidee", false);
      }
      this.$store.dispatch("setIdEntrepriseIdPlateforme", {
        idEntreprise: idEntreprise,
        idPlateforme: idPlateforme
      });
      if (token) {
        return token;
      }
    },
    readinitSearchUrlHashParams() {
      var urlString = window.location.href;
      var url = new URL(urlString);
      var initSearch = url.searchParams.get("initSearch");
      if (initSearch) {
        return initSearch;
      }
    }
  }
};
</script>

<style scoped>
.pageloader {
  background: #424a60 !important;
}
.pageloader-colidee {
  background: #e6ecf0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/base/Loading.vue